import { render, staticRenderFns } from "./ReportVotedSongPlataform.vue?vue&type=template&id=61424641"
import script from "./ReportVotedSongPlataform.vue?vue&type=script&lang=js"
export * from "./ReportVotedSongPlataform.vue?vue&type=script&lang=js"
import style0 from "./ReportVotedSongPlataform.vue?vue&type=style&index=0&id=61424641&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports